const initialState = () => ({
  shifts: [],
})

const getters = {
  SHIFTS: state => state.shifts,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_SHIFTS (state, shifts) {
    state.shifts = shifts
  },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
